<div class="fz-game-card__description">
  <div class="fz-game-card__description__root">
    <div class="fz-game-card__description__title">Description</div>
    <div class="fz-game-card__description__content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
